import axios from "axios";
import { apiAxiomLog } from "./logging";

export const apiGetAgendas = async (client, span, department) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/agendas/${client}?span=${span}&department=${department}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api engage apiGetAgendas");
    console.log(error);
    return null;
  }
};

export const apiGetUpcoming = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/upcoming/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api engage apiGetUpcoming");
    console.log(error);
    return null;
  }
};

export const apiGetVideoInfo = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/video/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api engage apiGetVideoInfo");
    console.log(error);
    return null;
  }
};

export const apiGetVideos = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/videos/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api engage apiGetVides");
    console.log(error);
    return null;
  }
};

export const apiGetVideosBySection = async (client, date, board) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/session/videos/${client}/${board}?range=${date}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api engage apiGetVides");
    console.log(error);
    return null;
  }
};

export const apiGetCachedMinutes = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/minutes/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      apiAxiomLog({
        stack: "frontEnd",
        function: "lib/api/engage apiGetCachedMinutes",
        params: id,
        error: { data: error.response.data, status: error.response.status },
      });
    } else if (error.request) {
      // The request was made but no response was received
      apiAxiomLog({
        stack: "frontEnd",
        function: "lib/api/engage apiGetCachedMinutes",
        params: id,
        error: { request: error.request },
      });
    }
    if (error.message !== "Network Error") {
      // Something happened in setting up the request that triggered an Error
      apiAxiomLog({
        stack: "frontEnd",
        function: "lib/api/engage apiGetCachedMinutes",
        params: id,
        error: error.message,
      });
    }
    return null;
  }
};

export const apiPublicSearch = async (client, string) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/search/items`,
        {
          clientId: client,
          string,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/engage apiPublicSearch",
      parms: { client, string },
      error: error.toString(),
    });
    return null;
  }
};

export const apiBoardPortalSearch = async (client, string) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/search/items?board=true`,
        {
          clientId: client,
          string,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/engage apiPublicSearch",
      parms: { client, string },
      error: error.toString(),
    });
    return null;
  }
};

export const apiGetAgenda = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/agenda/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    // Detailed error logging
    let errorDetails = {
      message: error.message,
      config: error.config,
    };

    if (error.response) {
      // The request was made and the server responded with a status code
      errorDetails.status = error.response.status;
      errorDetails.data = error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      errorDetails.request = error.request;
    }
    if (error.message !== "Network Error") {
      // Log detailed error
      apiAxiomLog({
        stack: "frontEnd",
        function: "lib/api/engage apiGetAgenda",
        params: id,
        error: errorDetails.data, // Log full error details object
      });
    }

    return null;
  }
};

export const apiGetAgendaPbp = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(`${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/pbp/${id}`, config)
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    // Detailed error logging
    let errorDetails = {
      message: error.message,
      config: error.config,
    };

    if (error.response) {
      // The request was made and the server responded with a status code
      errorDetails.status = error.response.status;
      errorDetails.data = error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      errorDetails.request = error.request;
    }
    if (error.message !== "Network Error") {
      // Log detailed error
      apiAxiomLog({
        stack: "frontEnd",
        function: "lib/api/engage apiGetAgendaPbp",
        params: id,
        error: errorDetails.data, // Log full error details object
      });
    }

    return null;
  }
};

export const apiGetAgendaPrint = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/print/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    // Detailed error logging
    let errorDetails = {
      message: error.message,
      config: error.config,
    };

    if (error.response) {
      // The request was made and the server responded with a status code
      errorDetails.status = error.response.status;
      errorDetails.data = error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      errorDetails.request = error.request;
    }

    if (error.message !== "Network Error") {
      // Log detailed error
      apiAxiomLog({
        stack: "frontEnd",
        function: "lib/api/engage apiGetAgendaPrint",
        params: id,
        error: errorDetails, // Log full error details object
      });
    }

    return null;
  }
};

export const apiNotifySubscribe = async (client, email) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/register/subscribe`,
        {
          clientId: client,
          email,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return { success: true };
        } else {
          return { success: false, data: response.data };
        }
      });
    return result;
  } catch (error) {
    // If error, get response data from backend
    if (error.response && error.response.data) {
      return {
        success: false,
        data: error.response.data, // includes reason and risk
        status: error.response.status,
      };
    } else {
      // Some other error (network, etc)
      return {
        success: false,
        data: null,
        status: null,
        message: error.message,
      };
    }
  }
};

export const apiNotifyUnSubscribe = async (client, email) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/register/unsubscribe`,
        {
          clientId: client,
          email,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    return null;
  }
};

export const apiNotifyList = async (client, meeting) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/register/notify`,
        {
          clientId: client,
          session: meeting,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    return null;
  }
};

export const apiNotifyListCancelled = async (client, meeting) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/register/notify-cancel`,
        {
          clientId: client,
          session: meeting,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    return null;
  }
};

export const apiSubscriberList = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/register/list/${client}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    return null;
  }
};

export const apiGetPublicCalendar = async (client, month) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/calendar/${client}?month=${month}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api engage apiGetAgendas");
    console.log(error);
    return null;
  }
};

export const apiGetHomeCalendar = async (client, month) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/calendar-home/${client}?month=${month}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api engage apiGetAgendas");
    console.log(error);
    return null;
  }
};

export const apiGetAgnedaPdfs = async (id) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/pdfs/${id}`,
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    // Detailed error logging
    let errorDetails = {
      message: error.message,
      config: error.config,
    };

    if (error.response) {
      // The request was made and the server responded with a status code
      errorDetails.status = error.response.status;
      errorDetails.data = error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      errorDetails.request = error.request;
    }
    if (error.message !== "Network Error") {
      // Log detailed error
      apiAxiomLog({
        stack: "frontEnd",
        function: "lib/api/engage apiGetAgendaPdfs",
        params: id,
        error: errorDetails.data, // Log full error details object
      });
    }

    return null;
  }
};

export const apiPublicSearchV2 = async (client, string, filters) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/search/items/v2`,
        {
          clientId: client,
          string,
          filters,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/engage apiPublicSearch",
      parms: { client, string },
      error: error.toString(),
    });
    return null;
  }
};

export const apiGlobalSearch = async (client, string, filters) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/engage/search/items/global`,
        {
          clientId: client,
          string,
          filters,
        },
        config,
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/engage apiPublicSearch",
      parms: { client, string },
      error: error.toString(),
    });
    return null;
  }
};
